import React, { useState } from 'react';
import { Card } from 'react-bootstrap';
import './HeaderCard.css';
import BasicDetailsModal from '../Common_profile_details_modals/BasicDetailsModal/BasicDetailsModal';

const HeaderCard = () => {
  const [showModal, setShowModal] = useState(false);

  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  return (
    <>
      <Card className="header-card">
        <Card.Body className="header-card__body">
          {/* Top Profile Section */}
          <div className="header-card__top">
            <div className="header-card__avatar">SL</div>
            <div className="header-card__meta">
              <div className="header-card__name-row">
                <h2 className="header-card__name">Smita Lad</h2>
                {/* Clicking this pencil now opens the modal */}
                <span 
                  className="header-card__edit-icon" 
                  onClick={handleOpenModal}
                  role="button"
                  aria-label="Edit basic details"
                >
                  ✏️
                </span>
              </div>
              <p className="header-card__role">Frontend Development Engineer</p>
              <p className="header-card__company">Profcyma Global Solutions</p>
              <p className="header-card__tenure-location">
                Jun 2023 - Present • 3 Yr 1 Mos <br /> Nagpur
              </p>
            </div>
          </div>
          
          <hr className="header-card__divider" />

          {/* Stats Metrics Section */}
          <div className="header-card__stats">
            <div className="header-card__stat-item">
              <span className="header-card__stat-label">Total exp</span>
              <strong className="header-card__stat-value">3 yrs 8 mos</strong>
            </div>
            <div className="header-card__stat-item">
              <span className="header-card__stat-label">Salary</span>
              <strong className="header-card__stat-value">
                INR 3.2L <span className="header-card__stat-sub">(Annually)</span>
              </strong>
            </div>
            <div className="header-card__stat-item">
              <span className="header-card__stat-label">Notice period</span>
              <strong className="header-card__stat-value">15 days</strong>
            </div>
          </div>
        </Card.Body>

        {/* Footer Alert Bar */}
        <Card.Footer className="header-card__footer">
          <span className="header-card__footer-icon">⏳</span>
          <span className="header-card__footer-text">Profile last updated on: 8 Jul, 2026</span>
        </Card.Footer>
      </Card>

      {/* Basic Details Modal implementation */}
      <BasicDetailsModal show={showModal} handleClose={handleCloseModal} />
    </>
  );
};

export default HeaderCard;